import React from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import { ExportDocumentsProvider } from "./hooks/useExportDocuments";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <ExportDocumentsProvider>
      <RouterProvider router={router} />
    </ExportDocumentsProvider>
  </React.StrictMode>
);
